import { useCurrentUser } from '@ianesthesie-kit/redux';
import { useMemo } from 'react';
import { AuthService } from '@ianesthesie-kit/services';
import { IanesthesieHeaders } from '@ianesthesie-kit/config';

export const useIsVerified = () => {
  const user = useCurrentUser();

  return useMemo(() => {
    if (!user) {
      return false;
    }

    const claims = AuthService.getInstance().parseAccessToken();
    return !!claims?.[IanesthesieHeaders.USER_VERIFIED];
  }, [user]);
};
